import { ReactElement } from 'react';
import { Divider, Grid } from '@mui/material';
import { useFormikContext } from 'formik';
import PmiTextField from 'shell/components/shared/text-field';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';
import { DateTime } from 'luxon';
import { DatePicker } from '@mui/lab';
import { noop } from 'shell/utils/noop';

interface OldAssignedOperator {
  service?: string;
  operator?: string;
  reason?: string;
  date?: DateTime | null;
}

interface FormAssignOperatorVM {
  oldService?: string;
  oldOperator?: string;
  newService?: string;
  newOperator?: string;
  reason?: string;
  oldOperatorsAssigned?: Array<OldAssignedOperator>;
}

const FormFilter = (): ReactElement => {
  const formContext = useFormikContext<FormAssignOperatorVM>();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={2}>
        <PmiTitleDivider>Assegnazione</PmiTitleDivider>
      </Grid>
      <Grid item xs={12} md={5}>
        <PmiTitleDivider>Servizio</PmiTitleDivider>
      </Grid>
      <Grid item xs={12} md={5}>
        <PmiTitleDivider>Operatore</PmiTitleDivider>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      {formContext.values.oldOperatorsAssigned?.map((item) => (
        <Grid item container xs={12} spacing={2} key={`${item?.service}_${item?.operator}`}>
          <Grid item xs={12} md={2}>
            <DatePicker
              label="Data"
              aria-label="Data"
              value={item.date || null}
              onChange={noop}
              disabled
              renderInput={(params) => (
                <PmiTextField
                  {...params}
                  id={`${item?.service}_${item?.operator}_documentDate`}
                  fullWidth
                  helperText=""
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={5}>
            <PmiTextField
              label="Servizio"
              aria-label="Servizio"
              id={`${item?.service}_${item?.operator}_service`}
              fullWidth
              value={item.service || ''}
              disabled
            />
          </Grid>
          <Grid item xs={12} md={5}>
            <PmiTextField
              label="Operatore"
              aria-label="Operatore"
              id={`${item?.service}_${item?.operator}_operator`}
              fullWidth
              value={item.operator || ''}
              disabled
            />
          </Grid>
          <Grid item xs={12}>
            <PmiTextField
              label="Motivo"
              aria-label="Motivo"
              id={`${item?.service}_${item?.operator}_reason`}
              fullWidth
              multiline
              rows={5}
              inputProps={{
                maxLength: '100',
              }}
              disabled
              value={item.reason || ''}
            />
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

FormFilter.displayName = 'Practice Assign - Form Old Assign Operator component';

export default FormFilter;
